export function formatSizeCheck(check) {
  if (check.min === check.max) {
    return `expected size: ${check.min}, actual size: ${check.actual}`;
  } else if (check.max !== null) {
    return `expected size: ${check.min} <= actual <= ${check.max}, actual size: ${check.actual}`;
  } else {
    return `expected size: ${check.min} <= actual, actual size: ${check.actual}`;
  }
}
